import { atom } from "recoil";
import { Company } from "@/features/types";
import { LineSheet } from "@/features/line-sheet-sets/line-sheet-set.types";

export const favoriteBrandSectionStore = atom<"STOCK" | "SEASON" | "API">({
  key: "favoriteBrandSectionStore",
  default: "STOCK",
});

export const favoriteBrandSectionRequestModalStore = atom<boolean>({
  key: "favoriteBrandSectionRequestModalStore",
  default: false,
});

export const favoriteBrandSectionLineSheetStore = atom<{
  [key: string]: LineSheet[];
}>({
  key: "favoriteBrandSectionLineSheetStore",
  default: {
    SEASON: [],
    STOCK: [],
  },
});

export const favoriteBrandSectionFavoriteBrandStore = atom<Company[]>({
  key: "favoriteBrandSectionFavoriteBrandStore",
  default: [],
});

export const favoriteBrandSectionScrollPositionStore = atom<{
  [key: string]: number;
}>({
  key: "favoriteBrandSectionScrollPositionStore",
  default: {
    SEASON: 0,
    STOCK: 0,
  },
});

export const favoriteBrandSectionLineSheetPageStore = atom<{
  [key: string]: {
    page: number;
    hasMore: boolean;
  };
}>({
  key: "favoriteBrandSectionLineSheetPageStore",
  default: {
    SEASON: {
      page: 1,
      hasMore: true,
    },
    STOCK: {
      page: 1,
      hasMore: true,
    },
  },
});
